module.exports = __webpack_public_path__ + "static/img/icon-04.c50df68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xyd/footer/icon-04.png
// module id = vvc5
// module chunks = 83